import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import AppBlog from './App.blog';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));


const host = window.location.hostname;

const RootApp = host.startsWith("blog.")
  ? <AppBlog />
  : <App />;

root.render(
  <React.StrictMode>
    {RootApp}
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
